import { useState, useEffect } from 'react';
import axiosJWT from './axiosJWT';
import { showToast } from '../Utils/toastUtils';
import { StartLoading, StopLoading } from '../Utils/loadingUtils';
import { useNavigate } from 'react-router-dom';
import getCookie from './getCookies';

const useGetUserData = () => {
    const [users, setUsers] = useState([]); // Start with null or empty array
    const [userPlan, setUserPlan] = useState([]); // Start with null or empty array
    const [Remainuser, setRemainuser] = useState(0); // Start with null or empty array
    const [subUser, setSubUser] = useState(0); // Start with null or empty array
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const getUsers = async () => {
            try {
                StartLoading(setIsLoading); // Starting loading spinner
                const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/sellerDetails`, {}, { withCredentials: true });
                if (response.data.success === 1) {
                    const userData = response.data.data; // Remove [0] since data is an object
                    const planData = response.data.PlanData; // Remove [0] since data is an object
                    // console.log(userData); // This should now show your data
                    setUsers([userData]); // Wrap in array if you expect an array
                    setUserPlan(planData); // Wrap in array if you expect an array
                    setRemainuser(response.data.Remainuser); // Wrap in array if you expect an array
                    setSubUser(response.data.subUser); // Wrap in array if you expect an array
                    StopLoading(setIsLoading);
                    // const userData = response.data.data[0]; // Directly assign the data
                    // // setUsers(userData);
                    // setUsers(Array.isArray(userData) ? userData : [userData]);
                    // StopLoading(setIsLoading); // Stop loading spinner
                } else {
                    StopLoading(setIsLoading);
                    showToast('Something went wrong! Please try again later', 'error');
                }
            }catch (err) {
            // console.log(err)
            if (err.response && err.response.data) {
                const { message, success } = err.response.data;

                if (success !== undefined && message) {
                    showToast(message, 'error');
                } else if (err.response.status === 401) {
                    window.location.reload();
                //    navigate('/', { replace: true });
                        showToast('logout', 'error');
                } else {
                    showToast("Failed to Add Category, please try again later", 'error');
                }
            } else if (err.message) {
                console.log('test success');
                showToast(err.message, 'error');
            } else {
                showToast("Something went wrong. Please try again.", 'error');
            }
        }
            
            
            // catch (err) {
            //     console.log(err.response);
            //     if (err.response && err.response.status === 401) {
            //         navigate('/', { replace: true });
            //     } else {
            //         StopLoading(setIsLoading);
            //         // window.location.reload();
            //         // showToast('Something went wrong! Please try again later', 'error');
            //     }
            // }
        };
        getUsers();
    }, [navigate]);

    return { users,userPlan,Remainuser,subUser, isLoading };
};

export default useGetUserData;
